export const PROPERTY_DATA_SCOPE = "data-scope";
export const PROPERTY_COUNTRIES = "countries";
